/**
 * Phone-only column sizing for the evidence tables (source rows, snippets).
 *
 * Those tables scroll sideways inside their own box, so on a phone every column
 * falls back to its narrowest width: a sentence wraps into a tall sliver while a
 * number keeps a wide empty column. Sizing by the cell's own length keeps short
 * values on one line and gives prose room to read. `md` and up is untouched.
 */
const SHORT_CELL_CHARS = 24
const LONG_CELL_CHARS = 48

export function phoneCellWidthClass(text: string): string {
  if (text.length <= SHORT_CELL_CHARS) return 'max-md:min-w-0 max-md:whitespace-nowrap'
  if (text.length <= LONG_CELL_CHARS) return 'max-md:min-w-44'
  return 'max-md:min-w-64'
}
